(function () {
  if (window.CartDrawerLecLoaded) return;
  window.CartDrawerLecLoaded = true;

  var SECTION_ID = 'cart-drawer';
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var NOTE_ONLY = 'cd-note=1';

  function getDrawer() {
    return document.querySelector('cart-drawer-lec');
  }

  // Watch every cart request on the page so the drawer always matches the cart.
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var args = arguments;
      var request = originalFetch.apply(this, args);
      try {
        var target = args[0];
        var url = typeof target === 'string' ? target : target && target.url;
        if (url && CART_CHANGE.test(url) && url.indexOf(NOTE_ONLY) === -1) {
          var isAdd = CART_ADD.test(url);
          request
            .then(function (response) {
              var drawer = getDrawer();
              if (!drawer) return;
              if (isAdd && !response.ok) return;
              drawer.refresh(isAdd);
            })
            .catch(function () {});
        }
      } catch (error) {}
      return request;
    };
  }

  // Product forms (including quick add) use the theme's cart pop-up. When the
  // drawer is on, swap the pop-up for the drawer; the fetch watcher opens it.
  function takeOverCartNotification() {
    var notification = document.querySelector('cart-notification');
    if (!notification || !getDrawer()) return;
    notification.renderContents = function () {
      var drawer = getDrawer();
      if (drawer) drawer.open();
    };
  }

  function isCartPage() {
    var cartUrl = (getDrawer() && getDrawer().dataset.cartUrl) || '/cart';
    return window.location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '');
  }

  document.addEventListener('click', function (event) {
    var icon = event.target.closest && event.target.closest('#cart-icon-bubble');
    if (!icon || !getDrawer() || isCartPage()) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    getDrawer().open();
  });

  class CartDrawerLec extends HTMLElement {
    connectedCallback() {
      this.onKeyUp = this.onKeyUp.bind(this);
      this.bind();
      takeOverCartNotification();
    }

    bind() {
      var self = this;

      this.querySelectorAll('[data-cd-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.close();
        });
      });

      this.querySelectorAll('[data-cd-qty]').forEach(function (button) {
        button.addEventListener('click', function () {
          self.change(button.dataset.key, parseInt(button.dataset.cdQty, 10));
        });
      });

      this.querySelectorAll('[data-cd-remove-keys]').forEach(function (button) {
        button.addEventListener('click', function () {
          var keys = button.dataset.cdRemoveKeys.split(',').filter(Boolean);
          self.removeKeys(keys);
        });
      });

      var note = this.querySelector('[data-cd-note]');
      if (note) {
        note.addEventListener('input', function () {
          clearTimeout(self.noteTimer);
          self.noteTimer = setTimeout(function () {
            self.saveNote(note.value);
          }, 500);
        });
      }

      this.placeTopUp();
    }

    // The free shipping bar renders its "Top it up with" picks inside the bar.
    // Move them below the items once the bar has picked them up.
    placeTopUp() {
      var self = this;
      customElements.whenDefined('shipping-progress').then(function () {
        var slot = self.querySelector('[data-cd-topup]');
        var picks = self.querySelector('.cd__bar .shipping-progress__suggestions');
        if (slot && picks) slot.appendChild(picks);
      });
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.lastFocus = document.activeElement;
      this.classList.add('is-visible');
      var self = this;
      requestAnimationFrame(function () {
        self.classList.add('is-open');
      });
      document.body.classList.add('cd-lock');
      document.addEventListener('keyup', this.onKeyUp);
      var panel = this.querySelector('.cd__panel');
      setTimeout(function () {
        var close = self.querySelector('.cd__close');
        (close || panel).focus({ preventScroll: true });
      }, 50);
    }

    close() {
      var self = this;
      this.classList.remove('is-open');
      document.body.classList.remove('cd-lock');
      document.removeEventListener('keyup', this.onKeyUp);
      setTimeout(function () {
        if (!self.classList.contains('is-open')) self.classList.remove('is-visible');
      }, 300);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }

    setBusy(busy) {
      this.classList.toggle('is-busy', busy);
    }

    post(url, body) {
      return window
        .fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body),
        })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'Error');
            return data;
          });
        });
    }

    root() {
      var root = this.dataset.root || '/';
      return root.endsWith('/') ? root : root + '/';
    }

    change(key, quantity) {
      this.setBusy(true);
      var self = this;
      this.post(this.root() + 'cart/change.js', { id: key, quantity: Math.max(0, quantity) }).catch(function (error) {
        self.setBusy(false);
        window.alert(error.message);
      });
    }

    removeKeys(keys) {
      if (!keys.length) return;
      var updates = {};
      keys.forEach(function (key) {
        updates[key] = 0;
      });
      this.setBusy(true);
      var self = this;
      this.post(this.root() + 'cart/update.js', { updates: updates }).catch(function (error) {
        self.setBusy(false);
        window.alert(error.message);
      });
    }

    saveNote(value) {
      window
        .fetch(this.root() + 'cart/update.js?' + NOTE_ONLY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ note: value }),
        })
        .catch(function () {});
    }

    refresh(openAfter) {
      var self = this;
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(function () {
        var url = self.root() + '?sections=' + SECTION_ID + ',cart-icon-bubble';
        originalFetch(url, { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .then(function (sections) {
            self.render(sections);
            if (openAfter) self.open();
          })
          .catch(function () {})
          .finally(function () {
            self.setBusy(false);
          });
      }, 60);
    }

    render(sections) {
      var html = sections && sections[SECTION_ID];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshInner = doc.querySelector('[data-cd-inner]');
        var inner = this.querySelector('[data-cd-inner]');
        if (freshInner && inner) {
          var scroller = inner.querySelector('.cd__body');
          var scrollTop = scroller ? scroller.scrollTop : 0;
          var noteOpen = inner.querySelector('.cd__note[open]');
          inner.innerHTML = freshInner.innerHTML;
          var newScroller = inner.querySelector('.cd__body');
          if (newScroller) newScroller.scrollTop = scrollTop;
          var note = inner.querySelector('.cd__note');
          if (note && noteOpen) note.open = true;
          this.bind();
        }
      }

      var bubbleHtml = sections && sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubble) {
        var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var source = bubbleDoc.querySelector('.shopify-section');
        if (source) bubble.innerHTML = source.innerHTML;
      }
    }
  }

  if (!customElements.get('cart-drawer-lec')) {
    customElements.define('cart-drawer-lec', CartDrawerLec);
  }

  document.addEventListener('DOMContentLoaded', takeOverCartNotification);
})();
